export default [
  {
    title: 'Inscripciones',
    route: 'inscripciones',
    icon: 'LogInIcon',
  },
]
